import React from 'react';

import { IconsGenerator } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/IconsGenerator/iconsGenerator';
import { CardIndicatorsKeys } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

import classes from './IndicatorsCell.module.scss';

interface Indicator {
    isIndicatorOn: boolean;
    text: string;
}

interface IndicatorWithName extends Indicator {
    name: CardIndicatorsKeys;
}

interface Props {
    cardIndicators?: any;
}

export const IndicatorsCell = ({ cardIndicators }: Props) => {
    let limitNumberOfIcon = 4;

    // sorted to make sure 'isKcRisk' first in array
    const sortedListOfIndicators: IndicatorWithName[] = [];
    cardIndicators &&
        Object.entries<Indicator>(cardIndicators).map(([key, value]) => {
            const typedKey = key as CardIndicatorsKeys;
            if (typedKey === 'isKcRisk') {
                sortedListOfIndicators.unshift({
                    name: typedKey,
                    isIndicatorOn: value.isIndicatorOn,
                    text: value.text,
                });
            } else {
                sortedListOfIndicators.push({ name: typedKey, isIndicatorOn: value.isIndicatorOn, text: value.text });
            }
        });

    return (
        <div data-testid={'activity-icons'} className={classes.IndicatorsCell}>
            {sortedListOfIndicators.map((item) => {
                if (item.isIndicatorOn && limitNumberOfIcon > 0) {
                    limitNumberOfIcon--;
                    return (
                        <IconsGenerator
                            key={item.name}
                            iconPropertyName={item.name}
                            show={item.isIndicatorOn}
                            customTitle={item.text}
                        />
                    );
                }
            })}
        </div>
    );
};
